/**
* Creates a key value object based on an array of compled objects with id property.
* Example [{id: 1, name: 'test'},{id:2, name:'test2'}]
* @param {Array} data
*/
const createResponse = (data) => {
  let res = {}
  Object.keys(data).forEach((key) => {
    res[data[key].id] = data[key]
  })
  return res
}

/**
* Creates a key value object based on an array such as ['CU', 'SE']
* @param {Array} data
*/
const createSimpleResponse = (data) => {
  let res = {}
  Object.keys(data).forEach((key) => {
    res[data[key]] = data[key]
  })
  return res
}

export {
  createResponse,
  createSimpleResponse
}



// WEBPACK FOOTER //
// ./src/api/response.js